module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"recommendations":"Weitere Angebote von {nickname}"},"en":{"recommendations":"More offers from {nickname}"}}')
  delete Component.options._Ctor
}
